import { Box, Button, Typography } from '@mui/material';
import { BackArrow } from 'components/BackArrow';
import { HistoryCard } from 'components/HistoryCard/HistoryCard';
import { getKetonesForPatientQuery } from 'dataLayer/ketones';
import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import useSelector from 'redux/useSelector';
import { paths } from 'routes';
import { colors } from 'theme';
import { Ketone } from 'types/types';
import ReactGA from 'react-ga';

export const KetonesHistory: FunctionComponent = () => {
  const userId = useSelector(state => state.user.id);
  const navigate = useNavigate();
  const { data: ketonesList, isLoading } = useQuery(getKetonesForPatientQuery(userId));

  const keytonesPageWrapper = useRef<HTMLDivElement>(null);

  const [appWidth, setAppWidth] = useState(0);

  const getAppWidth = () => {
    if (keytonesPageWrapper.current) setAppWidth(keytonesPageWrapper?.current?.offsetWidth);
  };

  useEffect(() => {
    getAppWidth();
    window.addEventListener('resize', getAppWidth);
  }, []);

  const navigateToRecord = useCallback(() => {
    ReactGA.event({
      category: 'ButtonClick',
      action: 'Record Ketones From History Page',
    });
    navigate(paths.RECORD_KETONES);
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        mx: 2,
        mb: 6,
      }}
      ref={keytonesPageWrapper}
    >
      <Box style={{ display: 'flex' }}>
        <Box style={{ flex: 1 }}>
          <BackArrow />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', mr: 2 }}>
          <Typography
            fontFamily="Poppins Medium"
            fontSize="18px"
            style={{ color: colors.darkPurple }}
          >
            <FormattedMessage id="ketones-history.title" />
          </Typography>
        </Box>
        <Box style={{ flex: 1 }}></Box>
      </Box>
      {ketonesList &&
        ketonesList.map((ketone: Ketone) => (
          <HistoryCard key={ketone.id} historyType="ketone" data={ketone} />
        ))}
      <Box
        position="fixed"
        height={48}
        bottom="0px"
        sx={{
          margin: '0 auto',
          width: '100%',
          mb: 2,
        }}
      >
        <Button
          variant="contained"
          onClick={navigateToRecord}
          style={{
            color: colors.white,
            backgroundColor: colors.darkPurple,
            width: `calc(${appWidth}px - 16px)`,
          }}
        >
          <FormattedMessage id="ketones-history.add-ketones-record" />
        </Button>
      </Box>
    </Box>
  );
};
